const API_DATA_REDUCER_KEYS = {
  META:                                    'meta',
  META_FETCH_STARTED_AT:                   'fetchStartedAt',
  META_SAVES_IN_PROGRESS:                  'savesInProgress',
  META_SAVES_IN_PROGRESS_STARTED_AT:       'saveStartedAt',
  META_SAVES_IN_PROGRESS_DATA_BEING_SAVED: 'dataBeingSaved',
  META_FIELDS_BEING_SAVED:                 'fieldsBeingSaved',
  META_UPDATED_AT:                         'updatedAt',
  META_TYPE:                               'type',
  META_TOTAL_COUNT:                        'totalCount',
  META_PAGE_COUNT:                         'pageCount',
  META_ERROR:                              'error',
  META_FAILED_ATTEMPTS:                    'failedAttempts',
  DATA:                                    'data',
};

export default API_DATA_REDUCER_KEYS;


// WEBPACK FOOTER //
// ./src/reducers/apiDataReducers.keys.js